import { useCallback, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { useAuth } from '@/auth/auth-provider';
import { GoogleButton } from '@/components/google-button';

export function LoginPage() {
  const navigate = useNavigate();
  const { status, loginWithGoogle } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const login = useCallback(async (credential: string) => {
    setError(''); setLoading(true);
    try { await loginWithGoogle(credential); navigate('/', { replace: true }); }
    catch (cause) { setError(cause instanceof Error ? cause.message : 'Sign-in failed'); }
    finally { setLoading(false); }
  }, [loginWithGoogle, navigate]);

  if (status === 'authenticated') return <Navigate to="/" replace />;
  return <main className="login-page">
    <section className="login-hero">
      <div className="brand" style={{ color: 'white', padding: 0 }}><img src="/futsaly-mark.svg" alt="" width={36} height={36} />Futsaly</div>
      <div><span className="badge live">SECURE OPERATIONS</span><h1>Run Afghan futsal<br />from one place.</h1><p style={{ maxWidth: 560, color: '#c7d6ee', fontSize: 18 }}>Manage teams, players, tournaments, seasons, fixtures, live match events, standings, and platform access.</p></div>
      <small style={{ color: '#9eb2d2' }}>Futsaly data entered before a federation agreement is demo or test data—not official federation data.</small>
    </section>
    <section className="login-panel">
      <div className="card login-card">
        <img src="/futsaly-mark.svg" width={58} height={58} alt="Futsaly" />
        <h1 style={{ margin: '22px 0 8px' }}>Admin sign in</h1>
        <p style={{ color: 'var(--muted)', margin: '0 0 28px' }}>Use the Google account attached to your invited Futsaly admin profile.</p>
        {error && <div className="error" style={{ marginBottom: 14 }}>{error}</div>}
        <GoogleButton onCredential={login} disabled={loading} />
        <p style={{ color: 'var(--muted)', fontSize: 12, lineHeight: 1.6, marginTop: 24 }}>Only active Main Admin, Federation, and Tournament Organizer accounts can enter. Court owners use the separate owner workspace. Signing in never creates an admin account.</p>
      </div>
    </section>
  </main>;
}
